const fields =
{
    name: 'Nazwa',
    tradeIndex: 'Indeks handlowy',
};
export default fields;